// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label_4d8ff6b7 {
  display: block;
  font-weight: 600;
}
.label_label_4d8ff6b7 {
  margin-bottom: 0.167rem;
}
.label_text_4d8ff6b7 {
  margin-bottom: 0;
  display: inline;
}
.label_ellipsis_4d8ff6b7 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.label_ellipsis_4d8ff6b7:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.label_ellipsis_4d8ff6b7:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
.label_ellipsis_4d8ff6b7 .label__item_4d8ff6b7 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.label_ellipsis_4d8ff6b7 .label__item_4d8ff6b7:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.label_ellipsis_4d8ff6b7 .label__item_4d8ff6b7:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `label_4d8ff6b7`,
	"label_label": `label_label_4d8ff6b7`,
	"label_text": `label_text_4d8ff6b7`,
	"label_ellipsis": `label_ellipsis_4d8ff6b7`,
	"label__item": `label__item_4d8ff6b7`
};
export default ___CSS_LOADER_EXPORT___;
